import React from "react";
import { observer } from "mobx-react";
import { ContractObservationUpdateStore } from "../../store";
import { ContractObservationUpdateForm } from "./ContractObservationUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ContractObservationUpdateProps = {
  contractObservationUpdateStore: ContractObservationUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ContractObservationUpdate: React.FC<ContractObservationUpdateProps> =
  observer(
    ({
      contractObservationUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={contractObservationUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={contractObservationUpdateStore.savedButOutdated}
            onReload={() =>
              contractObservationUpdateStore.reloadContractObservation()
            }
            reloadDisabled={contractObservationUpdateStore.isProcessing}
          />
          <ContractObservationUpdateForm
            contractObservationUpdateStore={contractObservationUpdateStore}
            titleError={contractObservationUpdateStore.errors.title?.message}
            onTitleChange={(value: string) => {
              contractObservationUpdateStore.setTitleValue(value);
            }}
            title={contractObservationUpdateStore.entityValues.title}
            observationError={
              contractObservationUpdateStore.errors.observation?.message
            }
            onObservationChange={(value: string) => {
              contractObservationUpdateStore.setObservationValue(value);
            }}
            observation={
              contractObservationUpdateStore.entityValues.observation
            }
            requireAllError={
              contractObservationUpdateStore.errors.requireAll?.message
            }
            onRequireAllChange={(value: boolean) => {
              contractObservationUpdateStore.setRequireAllValue(value);
            }}
            requireAll={contractObservationUpdateStore.entityValues.requireAll}
            authorsError={
              contractObservationUpdateStore.errors.authors?.message
            }
            onAuthorsChange={(value) => {
              contractObservationUpdateStore.setAuthorsValue(value);
            }}
            authorsSelectedValues={
              contractObservationUpdateStore.entityValues.showAuthors
            }
            onAuthorsSelected={(value) => {
              contractObservationUpdateStore.setSelectedAuthors(value);
            }}
            authorsOptions={contractObservationUpdateStore.getAuthorsOptions()}
            publishersError={
              contractObservationUpdateStore.errors.publishers?.message
            }
            onPublishersChange={(value) => {
              contractObservationUpdateStore.setPublishersValue(value);
            }}
            publishersSelectedValues={
              contractObservationUpdateStore.entityValues.showPublishers
            }
            onPublishersSelected={(value) => {
              contractObservationUpdateStore.setSelectedPublishers(value);
            }}
            publishersOptions={contractObservationUpdateStore.getPublishersOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={contractObservationUpdateStore.saveDisabled}
            onSave={() =>
              contractObservationUpdateStore.saveContractObservation()
            }
            onCancel={() =>
              contractObservationUpdateStore.cancelContractObservation()
            }
          />
          <ErrorDialog
            open={contractObservationUpdateStore.errorDialogOpened}
            title={contractObservationUpdateStore.errorTitle}
            description={contractObservationUpdateStore.errorDescription}
            onClose={() => contractObservationUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={contractObservationUpdateStore.confirmDialogOpened}
            title={contractObservationUpdateStore.confirmDialogTitle}
            description={
              contractObservationUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              contractObservationUpdateStore.executeConfirmedAction()
            }
            onCancel={() => contractObservationUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
